import { Navigation, Pagination, A11y, Grid } from 'swiper/modules'
import { defaultPreset } from './default'

export const sliderCardsPreset = {
  ...defaultPreset,
  speed: 1000,
  modules: [Navigation, Pagination, A11y, Grid],
  slidesPerView: 3,
  slidesPerGroup: 1,
  grid: {
    rows: 2,
  },
  spaceBetween: 24,
  // breakpoints: {
  //   731: {
  //     slidesPerView: 2,
  //     slidesPerGroup: 1,
  //   },
  //   1061: {
  //     slidesPerView: 3,
  //     slidesPerGroup: 1,
  //   },
  //   1281: {
  //     slidesPerView: 3,
  //     slidesPerGroup: 1,
  //     navigation: {
  //       enabled: true,
  //     },
  //   },
  // },
}
